import { render, staticRenderFns } from "./c_home_radio.vue?vue&type=template&id=4f283e42&scoped=true"
import script from "./c_home_radio.vue?vue&type=script&lang=js"
export * from "./c_home_radio.vue?vue&type=script&lang=js"
import style0 from "./c_home_radio.vue?vue&type=style&index=0&id=4f283e42&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f283e42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f283e42')) {
      api.createRecord('4f283e42', component.options)
    } else {
      api.reload('4f283e42', component.options)
    }
    module.hot.accept("./c_home_radio.vue?vue&type=template&id=4f283e42&scoped=true", function () {
      api.rerender('4f283e42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileFormConfig/c_home_radio.vue"
export default component.exports